import { axios } from "@/utils/axios";
import logger from "@/utils/logger";

import { GeocodedResultsProps } from "../../../interfaces/locations/location-interface";
import { transformGeocodedLocations } from "../../../interfaces/locations/location-transform";
import { SHOP_DIRECTORY_API_HOST } from "../../../shared/constants";

export const getGeocodedLocations = async (
    country: string,
    postcode: string
): Promise<GeocodedResultsProps> => {
    let result = null;
    try {
        const geocodedLocationsUrl = `${SHOP_DIRECTORY_API_HOST}/api/v1/geocode?address=${postcode}&country=${country}`;
        const geocodedLocationsResponse = await axios(geocodedLocationsUrl);
        const { status: httpStatus } = geocodedLocationsResponse;
        const { results, status: geocodeStatus } = geocodedLocationsResponse.data;

        if (httpStatus === 200 && geocodeStatus === "OK" && results[0]?.geometry?.bounds) {
            result = transformGeocodedLocations(results[0]);
        }
    } catch (ex) {
        const errorDescription = `failed to getGeocodedLocations postcode=${postcode} country=${country}`;
        logger.logException(ex, errorDescription);
        throw ex;
    }

    return result;
};
